import SubscriptionCardRepository from "../SubscriptionCardRepository"

export default class PricingBasicSubscription extends SubscriptionCardRepository {
    static schemaId = "pricing_card1"

    constructor() {
        super(PricingBasicSubscription.schemaId)
    }
}
